// PHOENIX-959: regra de complexidade da senha, a mesma do back (PoliticaSenha no core): no minimo 6 caracteres, com
// pelo menos uma letra, um numero e um caractere especial. Quem decide e o back; aqui so evita a ida e volta e mostra
// o que falta antes de enviar.
//
// Mesma classificacao do back (Character.isLetter / isDigit / isWhitespace + isSpaceChar): letra e qualquer letra
// Unicode (inclui acentuadas e o "ª"/"º" do teclado), numero e qualquer digito decimal, espaco inclui os separadores.
// Especial e o que nao e letra, nem numero, nem espaco.

export const TAMANHO_MINIMO_SENHA = 6

export const REGRA_SENHA =
  'A senha deve ter no mínimo 6 caracteres, com pelo menos uma letra, um número e um caractere especial.'

const isLetra = (c) => /\p{L}/u.test(c)
const isNumero = (c) => /\p{Nd}/u.test(c)
const isEspaco = (c) => /[\s\p{Z}]/u.test(c)

export const CONFIRMACAO_DIFERENTE = 'A confirmação não confere com a senha nova.'
export const NOVA_IGUAL_ATUAL = 'A senha nova não pode ser igual à atual.'

// Troca da senha vencida: o que da para conferir antes de ir ao back (que decide). Devolve a mensagem do primeiro
// problema, ou null. A senha atual e a que acabou de ser digitada no login.
export function erroNovaSenha({ novaSenha, confirmaSenha, senhaAtual }) {
  if (!senhaAtendePolitica(novaSenha)) {
    return REGRA_SENHA
  }
  if (novaSenha !== confirmaSenha) {
    return CONFIRMACAO_DIFERENTE
  }
  if (novaSenha === senhaAtual) {
    return NOVA_IGUAL_ATUAL
  }
  return null
}

export function senhaAtendePolitica(senha) {
  if (typeof senha !== 'string') {
    return false
  }
  // Array.from separa por caractere (code point), como o codePointCount do back
  const caracteres = Array.from(senha)
  if (caracteres.length < TAMANHO_MINIMO_SENHA) {
    return false
  }
  const temLetra = caracteres.some(isLetra)
  const temNumero = caracteres.some(isNumero)
  const temEspecial = caracteres.some((c) => !isLetra(c) && !isNumero(c) && !isEspaco(c))
  return temLetra && temNumero && temEspecial
}
